import React from 'react';

import Label from '../Label/Label';
import Input from '../Input/Input';
import Description from '../Description/Description';

import styles from './TextInput.module.css';
import { SettingsFeatureLock } from '../../LockedFeatures/SettingsFeatureLock';
const TextInput = ({
    field,
    changed = undefined,
    disabled = false,
    type = 'text',
    color = undefined,
    rows = undefined,
    placeholder = undefined,
    children,
    style = undefined,
    errorPadding = undefined,
    notificationPadding = undefined,
    labelId = undefined,
    inputId = undefined,
    maxWidth = undefined,
    className = '',
    featureLockId = undefined,
    featureLockIsTabId = undefined
}) => {
    const showErrorsRow = errorPadding || field.error;
    const showNotificationRow = notificationPadding || field.notification;
    return (
        <div className={styles.textInput + ` ${className}`} style={style}>
            <Label id={labelId} value={field.name} tooltip={field.tooltip} />
            <div className={styles.fieldsContainer}>
                {featureLockId ? (
                    <>
                        <Input
                            inputId={inputId}
                            {...field}
                            disabled={disabled}
                            type={type}
                            color={color}
                            placeholder={placeholder}
                            rows={rows}
                            changed={changed}
                            displayError={false}
                            displayNotifications={false}
                            maxWidth={maxWidth}
                            featureLockId={featureLockId}
                            featureLockIsTabId={featureLockIsTabId}
                        />
                        {children && (
                            <SettingsFeatureLock
                                id={featureLockId ?? field.id}
                                isTabId={!!featureLockIsTabId}
                                className="flex items-center">
                                <span className={styles.buttons}>{children}</span>
                            </SettingsFeatureLock>
                        )}
                    </>
                ) : (
                    <>
                        <Input
                            inputId={inputId}
                            {...field}
                            disabled={disabled}
                            type={type}
                            color={color}
                            placeholder={placeholder}
                            rows={rows}
                            changed={changed}
                            displayError={false}
                            displayNotifications={false}
                            maxWidth={maxWidth}
                        />
                        {children && <span className={styles.buttons}>{children}</span>}
                    </>
                )}
            </div>
            {showErrorsRow && <div className={styles.errorText}>{field.error || ''}</div>}
            {showNotificationRow && <div className={styles.notificationText}>{field.notification}</div>}
            {field.desc && <Description value={field.desc} />}
        </div>
    );
};

export default React.memo(TextInput);
